import React from 'react'
import {Box, Stack, Text} from '../../vanilla'
import {DynamicFormContent} from './dynamic-form-content'

export const ContactUsForms = () => {
  return (
    <Stack spacing="24px">
      <Box bg="white">
        <Box paddingY="24px" paddingX="20px" borderBottom="1px" borderColor="gray200">
          <Text variant="unstyled" fontSize="lg" fontWeight="normal" lineHeight="shorter">
            Couldn&apos;t find what you were looking for? Please contact us by completing the form
            below.
          </Text>
        </Box>
        <DynamicFormContent />
      </Box>
    </Stack>
  )
}
